export default __webpack_public_path__ + "static/media/empty-betslip.7668ca75.png";